export default {
    scheduled_actions_tab_entity_name: "Entity Name",
    scheduled_actions_tab_name: "Name",
    scheduled_actions_tab_action: "Action",
    scheduled_actions_tab_scheduled_on: "Schedule On",
    scheduled_actions_tab_executed: "Executed",
    scheduled_actions_tab_created_on: "Created On",
    scheduled_actions_tab_created_by: "Created By",
    scheduled_actions_tab_updated_on: "Updated On",
    scheduled_actions_tab_edit: "Edit",
    scheduled_actions_tab_delete: "Delete",
    scheduled_actions_tab_edit_is_executed: "Scheduled actions that have already been executed cannot be edited",
    scheduled_actions_tab_delete_is_executed: "Scheduled actions that have already been executed cannot be deleted",
    scheduled_actions_tab_updated_by: "Updated By",
    scheduled_actions_error: "Error",
};







